const Footer = () => (
  <footer className="bg-[#111] text-white text-center py-[15px]">
    © 2025 AmarInFratech. All Rights Reserved.
  </footer>
);

export default Footer;
